// getDecryptedResourcesData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

const defaultSelectPath = [];
const defaultDataKey = '';

/**
 * Select decrypted resource's data by select path
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} selectPath - select path.
 * @param {string} dataKey - data key.
 * @return {any} The selected data of decrypted resource.
 */
const getDecryptedResourcesData = createCachedSelector(
  (state, selectPath = defaultSelectPath) =>
    state.getIn(['decryptedResources', ...selectPath]),
  (state, selectPath, dataKey) => dataKey,
  (decryptedResource, dataKey = defaultDataKey) => {
    let result = decryptedResource;
    if (dataKey) {
      result = decryptedResource?.get(dataKey);
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, selectPath = defaultSelectPath, dataKey = defaultDataKey) =>
    `${selectPath.join(':')}:${dataKey}`
);

export default getDecryptedResourcesData;
